import React from 'react';
import Menu from '@tencent/dui/lib/components/Menu';
import i18n from '@i18next/i18n';
import ToolbarSettingIcon from '@tencent/docs-design-resources/pc/svg/toolbar_setting.svg';

interface IMoreConfigMenuProps {
    onClick(): void;
}

export class MoreConfigMenu extends React.Component<IMoreConfigMenuProps, any> {
    render() {
        return <Menu.Item
            style={{
                paddingLeft: 12,
            }}
            icon={ToolbarSettingIcon}
            onClick={this.props.onClick}
        >
            {i18n.t('更多格式设置')}
        </Menu.Item>;
    }
}
